exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChatPreview_chat__25SAr {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  padding: 7px 10px 10px 10px;\n  box-sizing: border-box; }\n  .ChatPreview_chat__25SAr .ChatPreview_header__3AspH {\n    display: -webkit-flex;\n    display: flex;\n    position: relative;\n    -webkit-flex-direction: column;\n            flex-direction: column;\n    min-height: 48px; }\n    .ChatPreview_chat__25SAr .ChatPreview_header__3AspH .ChatPreview_title__3-Y-a {\n      display: -webkit-flex;\n      display: flex;\n      position: absolute;\n      -webkit-align-items: center;\n              align-items: center;\n      height: 48px;\n      width: 100%; }\n  .ChatPreview_chat__25SAr .ChatPreview_iframe__2Xz8k {\n    border-radius: 12px;\n    border: 1px solid #d9d9d9;\n    overflow: hidden; }\n", ""]);

// exports
exports.locals = {
	"chat": "ChatPreview_chat__25SAr",
	"header": "ChatPreview_header__3AspH",
	"title": "ChatPreview_title__3-Y-a",
	"iframe": "ChatPreview_iframe__2Xz8k"
};